import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import ScrollToTop from 'common/ui/ScrollToTop';
import {
  ENV_NAME,
  GOOGLE_OAUTH_CLIENT_ID,
  themeConfig,
} from 'config/env-config';
import { AuthProvider } from 'context/auth-context';
import { queryClient } from 'lib/query-client';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';

import 'assets/styles/custom.css';
import 'assets/styles/global.css';

const App = () => {
  const isProd = ENV_NAME === 'production';
  const theme = isProd
    ? {}
    : {
        token: {
          colorPrimary: themeConfig.primaryColor,
        },
      };

  return (
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
        <React.StrictMode>
          <HelmetProvider>
            <ConfigProvider theme={theme}>
              <BrowserRouter>
                <ScrollToTop />
                <AuthProvider>
                  <AppRouter />
                </AuthProvider>
              </BrowserRouter>
            </ConfigProvider>
          </HelmetProvider>
        </React.StrictMode>
      </GoogleOAuthProvider>
      {!isProd && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};

export default App;
